export const GROUP_CREATED_BY_USER = 0
